import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { OPEN_STICKER } from "../../store/Sticker/Sticker.type";
import { warning } from "../../util/Alert";
import StickerDialog from "../Dialog/StickerDialog";
import TablePaginationActions from "../../util/Pagination";
import dayjs from "dayjs";
import { TablePagination } from "@mui/material";
import { getSticker, deleteSticker } from "../../store/Sticker/Sticker.action";
import noImage from "../../assets/img/No_image.png";

const Sticker = (props) => {
  const dispatch = useDispatch();
  const { sticker } = useSelector((state) => state.sticker);

  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Load stickers
  useEffect(() => {
    dispatch(getSticker());
  }, [dispatch]);

  // Update data
  useEffect(() => {
    setData(sticker);
  }, [sticker]);

  // Pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Open Dialog
  const handleOpen = () => {
    dispatch({ type: OPEN_STICKER });
  };

  // Edit
  const handleEdit = (data) => {
    dispatch({ type: OPEN_STICKER, payload: data });
  };

  // Delete
  const handleDelete = (id) => {
    const data = warning();
    data.then((isDeleted) => {
      if (isDeleted) {
        props.deleteSticker(id);
      }
    });
  };

  return (
    <>
      <div className="row py-2">
        <div className="col-2">
          <h4 className="hostTitle">Sticker</h4>
        </div>
        <div className="col-10">
          <div className="breadcrumb-four float-right">
            <ul className="breadcrumb">
              <li>
                <Link to="/admin/dashboard">
                  <i className="fas fa-home"></i>
                </Link>
              </li>
              <li className="active">Sticker</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="row layout-top-spacing">
        <div className="col-lg-12 col-12 layout-spacing">
          <div className="statbox widget">
            <div className="widget-content widget-content-area">
              <div className="row mb-3">
                <div className="col-8">
                  <button
                    className="btn btn-danger text-white"
                    onClick={handleOpen}
                  >
                    <i className="fa fa-plus pr-1"></i> Add
                  </button>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table text-center table-striped">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Image</th>
                      <th>Created At</th>
                      <th>Edit</th>
                      <th>Delete</th>
                    </tr>
                  </thead>

                  <tbody>
                    {data?.length > 0 ? (
                      (rowsPerPage > 0
                        ? data.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                        : data
                      ).map((item, i) => (
                        <tr key={item._id}>
                          <td>{page * rowsPerPage + i + 1}</td>

                          <td>
                            <img
                              src={item?.sticker}
                              alt="sticker"
                              draggable="false"
                              style={{
                                width: "100px",
                                height: "100px",
                                borderRadius: "12px",
                                objectFit: "cover",
                              }}
                              onError={(e) => {
                                e.target.src = noImage;
                              }}
                            />
                          </td>

                          <td>
                            {dayjs(item?.createdAt).format("DD MMM YYYY")}
                          </td>

                          <td>
                            <button
                              className="btn btn-info"
                              onClick={() => handleEdit(item)}
                            >
                              <i className="fas fa-edit" />
                            </button>
                          </td>

                          <td>
                            <button
                              className="btn btn-danger"
                              onClick={() => handleDelete(item._id)}
                            >
                              <i className="fas fa-trash-alt" />
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No Data Found !
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, 50, 100]}
                  component="div"
                  count={data?.length}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </div>
            </div>
          </div>
        </div>

        <StickerDialog />
      </div>
    </>
  );
};

export default connect(null, { getSticker, deleteSticker })(Sticker);
